module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_0.6fd17479.jpg";